import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Box, useColorMode } from "@chakra-ui/react";
import { Subtitle } from "src/atoms/typography";
import IconOnBackgound from "src/components/IconOnBackground";
import icons from "src/modules/command/commands-icons";
import colors from "src/modules/command/colors";
import { ReactComponent as StopIcon } from "src/modules/command/icons/stop.svg";
import { ReactComponent as PlayIcon } from "src/modules/command/icons/play.svg";
import AudioPlayer from "src/components/AudioPlayer";
import CommandViewMenu from "./CommandViewMenu";

export default function CommandView({
  openEditor,
  name,
  color: colorName,
  icon: iconName,
  audioDuration,
  toggleCommandReplay,
  onDelete,
  audioPlayer
}) {
  const { t } = useTranslation();
  const { colorMode } = useColorMode();
  const isDarkMode = colorMode === "dark";

  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const toggleMenu = () => setIsMenuOpened((prev) => !prev);

  let controlIcon = icons[iconName].icon;
  if (isHovered) {
    controlIcon = PlayIcon;
  }
  if (audioPlayer) {
    controlIcon = StopIcon;
  }

  return (
    <Flex alignItems="center" justifyContent="space-between" py="8px" pr="3px">
      <Flex alignItems="center" mr="4px" flexGrow={1}>
        <Flex
          onClick={toggleCommandReplay}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          alignItems="center"
        >
          <IconOnBackgound
            size="40px"
            iconSize="20px"
            bg={
              audioPlayer && !isDarkMode
                ? "white"
                : audioPlayer && isDarkMode
                ? "white12"
                : colors[colorName].name
            }
            icon={controlIcon}
            fill={audioPlayer ? colors[colorName].name : "white"}
            mr="16px"
            {...(audioPlayer &&
              !isDarkMode && {
                boxShadow: `0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 1px 16px 0 rgba(0, 0, 0, 0.06), 0 4px 8px 0 rgba(0, 0, 0, 0.08)`
              })}
          />
          {audioPlayer == null && (
            <Subtitle color="highEmphasis">
              {name || t(`command.name.${iconName}`)}
            </Subtitle>
          )}
        </Flex>
        {audioPlayer && (
          <Box flexGrow={1}>
            <AudioPlayer
              getCurrentTime={audioPlayer?.getCurrentTime}
              duration={audioDuration}
            />
          </Box>
        )}
      </Flex>
      <CommandViewMenu
        openEditor={openEditor}
        isOpen={isMenuOpened}
        onDelete={() => {
          toggleMenu();
          onDelete();
        }}
        onClose={toggleMenu}
        onOpen={toggleMenu}
      />
    </Flex>
  );
}
